// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_modules_main_main_module_ts":"868aa8b0482ff963","src_app_modules_login_login_module_ts":"0180975fa83ffa3c","src_app_modules_app-connect_app-connect_module_ts":"d9e707d1d1c5782c","src_app_modules_main_app-list_app-list_module_ts":"53a4208d993a4883"}[chunkId] + ".js";
};